import { render, staticRenderFns } from "./IconRewardTotalDelivery.vue?vue&type=template&id=526f2f52"
import script from "./IconRewardTotalDelivery.vue?vue&type=script&lang=js"
export * from "./IconRewardTotalDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports